import React from 'react';
import { KizenTypography } from 'app/typography';
import {
  StyledWizardBody,
  StyledStepNumber,
  StyledStepHeader,
  StyledProgress,
  StyledProgressLine,
  StyledModalSection,
} from '../styles';

const Section = ({
  active,
  index,
  title,
  children,
  done,
  last,
  headerAction,
}) => {
  return (
    <>
      <StyledWizardBody className="GenericWizardBody">
        <StyledStepNumber active={active || done}>
          <div>{index + 1}</div>
        </StyledStepNumber>
        <StyledStepHeader>
          <KizenTypography type="header">{title}</KizenTypography>
          {headerAction}
        </StyledStepHeader>
        {last ? (
          <div />
        ) : (
          <StyledProgress>
            <StyledProgressLine active={active || done} />
          </StyledProgress>
        )}
        <StyledModalSection last={last}>
          {active || done ? children : null}
        </StyledModalSection>
      </StyledWizardBody>
    </>
  );
};

export default Section;
